export default __webpack_public_path__ + "static/media/step-current.a812206d.svg";